import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import { useToast } from "@/components/ui/use-toast";
import { useSearchParams } from "react-router-dom";
import { GoogleAuthButton } from "./GoogleAuthButton";
import { TermsAndConditionsDialog } from "./TermsAndConditionsDialog";

export const SignUpForm = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [showTermsDialog, setShowTermsDialog] = useState(false);
  const [searchParams] = useSearchParams();
  const { toast } = useToast();

  // Get UTM parameters from URL
  const utmSource = searchParams.get("utm_source") || "";
  const utmMedium = searchParams.get("utm_medium") || "";
  const utmCampaign = searchParams.get("utm_campaign") || "";
  const utmContent = searchParams.get("utm_content") || "";
  const utmTerm = searchParams.get("utm_term") || "";
  const referrer = document.referrer || "";

  return (
    <div className="space-y-4">
      <GoogleAuthButton 
        isLoading={isLoading} 
        setIsLoading={setIsLoading} 
        termsAccepted={termsAccepted} 
      />

      <div className="flex items-start space-x-2 py-2">
        <Checkbox 
          id="terms" 
          checked={termsAccepted}
          onCheckedChange={(checked) => setTermsAccepted(checked === true)}
        />
        <div className="grid gap-1.5 leading-none">
          <label
            htmlFor="terms"
            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
          >
            I accept the{" "}
            <button
              type="button"
              className="text-gebeya-pink hover:underline focus:outline-none"
              onClick={() => setShowTermsDialog(true)}
            >
              Terms and Conditions
            </button>
          </label>
        </div>
      </div>
      
      <TermsAndConditionsDialog 
        open={showTermsDialog} 
        onOpenChange={setShowTermsDialog} 
      />
    </div>
  );
};
